import { useEffect } from "react";
import { useScrollReveal } from "@/hooks/useScrollReveal";
import Navbar from "@/pages/home/components/Navbar";
import Footer from "@/pages/home/components/Footer";
import WhatsAppFloat from "@/pages/home/components/WhatsAppFloat";
import RevitHero from "./components/RevitHero";
import RevitIntro from "./components/RevitIntro";
import RevitServices from "./components/RevitServices";
import RevitBim from "./components/RevitBim";
import RevitAdvantages from "./components/RevitAdvantages";
import RevitProcess from "./components/RevitProcess";
import RevitApplications from "./components/RevitApplications";
import RevitCta from "./components/RevitCta";

export default function DisenoRevitBim() {
  useScrollReveal();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-background-50 font-body text-foreground-900">
      <Navbar />
      <main>
        <RevitHero />
        <RevitIntro />
        <RevitServices />
        <RevitBim />
        <RevitAdvantages />
        <RevitProcess />
        <RevitApplications />
        <RevitCta />
      </main>
      <Footer />
      <WhatsAppFloat />
    </div>
  );
}